import { render, staticRenderFns } from "./InformasiBongkar.vue?vue&type=template&id=08a4e31f&scoped=true"
import script from "./InformasiBongkar.vue?vue&type=script&lang=js"
export * from "./InformasiBongkar.vue?vue&type=script&lang=js"
import style0 from "./InformasiBongkar.vue?vue&type=style&index=0&id=08a4e31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4e31f",
  null
  
)

export default component.exports